import { createFileRoute } from '@tanstack/react-router';

import { queryKeys } from '@constants/queryKeys.constant';
import { serviceRequestTaskTypeOptions } from '@constants/tasks.constant';
import { ETaskLevel } from '@enums/task.enum';
import { TaskCreateForm } from '@routes/_layout.(private)/tasks/@components/CreateForm';

export const Route = createFileRoute(
  '/_layout/(private)/service-requests/$id/tasks/create',
)({
  component: ServiceRequestTasksCreate,
});

function ServiceRequestTasksCreate() {
  const { id: serviceRequestId } = Route.useParams();

  return (
    <TaskCreateForm
      level={ETaskLevel.ServiceRequest}
      parentId={serviceRequestId}
      queryKeyToToggle={queryKeys.serviceRequests.detail(serviceRequestId)}
      serviceRequestId={serviceRequestId}
      typeOptions={serviceRequestTaskTypeOptions}
    />
  );
}
